/* polyfills */
import '@babel/polyfill';
import 'element-closest';
import 'mdn-polyfills/NodeList.prototype.forEach';
import 'mdn-polyfills/Node.prototype.remove';
import 'mdn-polyfills/Array.prototype.forEach';
import 'mdn-polyfills/Element.prototype.classList';

/* vue */
import Vue from 'vue';
import App from './App.vue';

/* vuejs-dialog */
import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
Vue.use(VuejsDialog);

/* router */
import router from './router/router';

/* vuex-router-sync */
import { sync } from 'vuex-router-sync';
sync(store, router);

/* store */
import store from './store/store';

/* vue-notification */
import Notifications from 'vue-notification';
Vue.use(Notifications);

/* v-tooltip */
import VTooltip from 'v-tooltip';
Vue.use(VTooltip);
VTooltip.options.autoHide = true;
import { isTouchDevice } from '@/helpers/utils';
VTooltip.enabled = !isTouchDevice();

/* easter-egg-collection */
import collection from 'easter-egg-collection';
collection;

/* jwtbutler */
import jwtbutler from './helpers/jwtbutler';
Vue.prototype.$api = jwtbutler;

/* helpers */
import helpers from './helpers/global';
Vue.use({
    install() {
        Vue.helpers = helpers;
        Vue.prototype.$helpers = helpers;
    }
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
    created() {}
}).$mount('#app');
